import { useGetInterestRateQuery } from "@/services/authAPI";
import {
  ActionIcon,
  Card,
  Group,
  Modal,
  ScrollArea,
  Table,
  Tabs,
  Text,
  TextInput,
} from "@mantine/core";
import { IconDownload, IconSearch } from "@tabler/icons-react";
import { get } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const tabSx = {
  "&[data-active]": {
    color: "#2A81D0",
    fontWeight: 600,
    borderBottom: "2px solid #2A81D0",
  },
  "&[data-active]:hover": {
    borderBottom: "2px solid #2A81D0",
  },
  height: "40",
};
interface Props {
  opened: boolean;
  close: () => void;
}
// VersionEn: mảng này là dữ liệu giả CHẾT — bảng render từ `result` của useGetInterestRateQuery,
// không dùng `data`. Không dịch để khỏi tạo key vô ích.
const data = [
  {
    name: "Lãi suất huy động Khách hàng Tổ chức",
    date: "13/11/2025",
  },
  {
    name: "Lãi suất huy động Khách hàng ",
    date: "13/11/2025",
  },
];
const InterestRate = ({ opened, close }: Props) => {
  const { t, i18n } = useTranslation();
  const isEnglish = (i18n.language || "vi").startsWith("en");
  /**
   * Tên biểu lãi suất: backend đã trả sẵn bản tiếng Anh ở `nameEN`, màn này
   * trước đây bỏ qua nên luôn hiện tiếng Việt. Thiếu bản EN thì lùi về `name`.
   */
  const pickRateName = (item: { name?: string; nameEN?: string }): string =>
    (isEnglish && item?.nameEN) || item?.name || "";
  const arr = Array.from({ length: 5 });
  const [search, setSearch] = useState("");
  const { data: interestRateData } = useGetInterestRateQuery();
  const result = get(interestRateData, "body.interestRates", []);

  const handleDownload = (item: any) => {
    const link = document.createElement("a");
    link.href = item?.file;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Modal
      opened={opened}
      onClose={close}
      size="50%"
      centered
      withCloseButton
      title={<Text fw={600}>{t("INTEREST_RATE_INFORMATION")}</Text>}
    >
      <Card p="0">
        {/* Ô tìm kiếm */}
        <TextInput
          placeholder={`${t("TERMS_CONDITIONS_NAME_PLACEHOLDER")}`}
          icon={<IconSearch size={16} />}
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value)}
          mb="md"
        />

        {/* Tabs */}
        <Tabs defaultValue="tien-gui">
          <Tabs.List>
            <Tabs.Tab sx={tabSx} value="tien-gui">
              {t("DEPOSITS_TAB")}
            </Tabs.Tab>
            <Tabs.Tab sx={tabSx} value="vay-co-so">
              {t("BASE_LENDING_TAB")}
            </Tabs.Tab>
          </Tabs.List>

          {/* Nội dung Tab “Thẻ” */}
          <Tabs.Panel value="tien-gui" pt="md">
            <ScrollArea h={250}>
              <Table verticalSpacing="sm" highlightOnHover>
                <thead>
                  <tr>
                    <th>{t("TERMS_CONDITIONS_NAME")}</th>
                    <th>{t("EFFECTIVE_DATE")}</th>
                    <th>{t("DOWNLOAD_FILE")}</th>
                  </tr>
                </thead>
                <tbody>
                  {result.map((item, idx) => (
                    <tr key={`${item.name}-${item.effectDate}`}>
                      <td>{pickRateName(item)}</td>
                      <td>
                        <Text fw={600}>{item.effectDate}</Text>
                      </td>
                      <td>
                        <Group spacing={6} onClick={() => handleDownload(item)}>
                          <ActionIcon
                            variant="subtle"
                            color="blue"
                            component="a"
                            href="#"
                            title={`${t("VIEW_DETAILS")}`}
                          >
                            <IconDownload size={18} />
                          </ActionIcon>
                          <Text
                            size="sm"
                            c="blue"
                            style={{ cursor: "pointer" }}
                          >
                            {t("DOWNLOAD_FILE")}
                          </Text>
                        </Group>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </ScrollArea>
          </Tabs.Panel>

          {/* Các tab khác (chưa có dữ liệu) */}
          <Tabs.Panel value="vay-co-so" pt="md">
            <Text size="sm" c="dimmed">
              {t("NO_DATA_YET")}
            </Text>
          </Tabs.Panel>
        </Tabs>
      </Card>
    </Modal>
  );
};

export default InterestRate;
